import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import api from "../../setupMiddleware";
import useApiLoader from "../../Utils/useApiLoader";
import { ToastContainer, toast, Bounce } from "react-toastify";

export default function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const loading = useApiLoader();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email) return setError("Please enter your email address.");
    await api
      .post("/api/forgot-password", {
        email: email,
      })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          setTimeout(() => {
            window.location = "/";
          }, 1500);
        }
      })
      .catch((error) => {
        console.log("Error", error);
        if (error) {
          toast.warning(error.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 to-white flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.42 }}
        className="w-full max-w-md bg-white/90 backdrop-blur-md rounded-2xl shadow-lg p-8"
      >
        <header className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand text-white text-2xl font-bold mx-auto shadow-md">
            GYI
          </div>
          <h1 className="mt-4 text-2xl font-bold text-brand">
            Forgot Password?
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Enter your email to receive a reset link
          </p>
        </header>

        <form
          onSubmit={handleSubmit}
          className="space-y-4"
          aria-label="forget password form"
        >
          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-100 p-3 rounded">
              {error}
            </div>
          )}

          <div>
            <label
              className="block text-sm font-medium text-gray-700 mb-1"
              htmlFor="email"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-brand/20 focus:border-brand/40"
              placeholder="you@company.com"
              autoComplete="email"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 py-2.5 rounded-lg bg-brand text-white font-medium shadow hover:opacity-95 disabled:opacity-60"
          >
            {loading ? (
              <svg
                className="w-4 h-4 animate-spin"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                ></path>
              </svg>
            ) : null}
            <span>{loading ? "Sending..." : "Send Reset Link"}</span>
          </button>

          <p className="mt-4 text-center text-sm text-gray-600">
            Remember your password?{" "}
            <Link to="/" className="text-brand font-medium hover:underline">
              Sign in
            </Link>
          </p>
        </form>

        <footer className="mt-6 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} Get Your Info. All rights reserved.
        </footer>
      </motion.div>
      <ToastContainer />
    </div>
  );
}
